(function HotelSheets($, Adzuki)
{
	"use strict";

	var map = null;

	$(document).ready(function documentReady()
	{
		var hotelSheetPages = ['/HotelSheets/view'];

		Adzuki.onload(hotelSheetPages, function onload()
		{
			var max_time      = 600, // max amount of seconds before we refresh (10 minutes)
			    current_timer = 0,
			    interval;

			// load hotel room rates
			getHotelRoomRates();

			// load hotel images
			getHotelImages();

			// load google map
			loadMap();

			// reload the hotel sheet every 10 minutes to refresh hotel session data
			interval = setInterval(
				function _updateCurrentTimer() {
					$('#timer-val').html(fancyTimeFormat(parseFloat(max_time - current_timer)));

					if (current_timer >= max_time) {
						clearInterval(interval);

						location.reload();
					}

					current_timer++;
				},
				1000
			);
		}, false);
	});

	function loadMap()
	{
		if (map === null) {
			map = new Adzuki.Map(
				$('.hotel-map'), {
					zoom: 12,
					init: function map_init(_map) {
						_map.populate($('.hotel-map').data('map-markers'));
					}
				}
			);
		}
	}

	function getHotelImages()
	{
		var hotel_sheet_id = $('.tour-sheet-header').data('hotel-sheet-id');

		if (!hotel_sheet_id) {
			throw new Error('missing hotel_sheet_id');
		}

		Adzuki.Ajax.get('/HotelSheets/getHotelImages/' + hotel_sheet_id)
			.then(function success(response) {
				$('.hotel-images').html(response);

				// handle gallery click
				$('.ajax-image-gallery').click(function _showGallery() {
					var $el            = $(this),
						index          = parseInt($(this).data('index')),
						hotel_gallery  = null,
						url            = '/HotelSheets/getGalleryImages/',
						giata_id       = $el.data('giata-id') || $el.parent().data('giata-id');

					if (!giata_id) {
						throw new Error('missing giata-id');
					}

					url += giata_id;

					Adzuki.Ajax.post(url).then(function sucess(response) {
						var images         = response;
						var gallery_images = [];

						if (images.length === 0) {
							return;
						}

						$.each(images, function onEachImage(i, image) {
							gallery_images.push({
								src    : image.src,
								thumb  : image.thumb,
								subHtml: image.subHtml,
							});
						});

						hotel_gallery = lightGallery($el[0], {
							licenseKey       : 'github',
							download         : false,
							plugins          : [lgThumbnail],
							dynamic          : true,
							thumbnail        : true,
							toggleThumb      : true,
							allowMediaOverlap: true,
							index            : index,
							dynamicEl        : gallery_images,
						});

						hotel_gallery.openGallery();
					});
				});
			})
			.catch(function error(err) {
				console.error('Error fetching hotel images:', err);
				Adzuki.StatusMessage('Error', 'Unable to load hotel images.');
			});
	}

	function getHotelRoomRates()
	{
		var hotel_sheet_id = $('.tour-sheet-header').data('hotel-sheet-id');

		if (!hotel_sheet_id) {
			throw new Error('missing hotel_sheet_id');
		}

		Adzuki.Ajax.get('/HotelSheets/getHotelRoomRates/' + hotel_sheet_id)
			.then(function success(response) {
				$('.hotel-rooms').html(response);

				// room gallery
				$('.room-image').click(function _showRoomGallery() {
					var room_gallery = null,
					    $self        = $(this),
					    image_json   = $self.data('gallery-images');

					room_gallery = lightGallery($self[0], {
						licenseKey       : 'github',
						download         : false,
						plugins          : [lgThumbnail],
						dynamic          : true,
						thumbnail        : true,
						toggleThumb      : true,
						allowMediaOverlap: true,
						dynamicEl        : image_json,
					});

					room_gallery.openGallery();
				});

				// Add new specialty rate amenities handler
				$('.specialty-rate-amenities').each(function _loadSpecialtyRateAmenities() {
					var $amenities     = $(this),
					    sabre_hotel_id = $amenities.data('sabre-hotel-id'),
					    rate_code      = $amenities.data('rate-code'),
					    checkin        = $amenities.data('checkin'),
					    checkout       = $amenities.data('checkout');

					if (!sabre_hotel_id || !rate_code) {
						console.error('Missing required data attributes for specialty rate amenities');
						return;
					}

					Adzuki.Ajax.get('/HotelSheets/getHotelSpecialtyRateAmenities/' + sabre_hotel_id + '/' + rate_code + '/' + checkin + '/' + checkout)
						.then(function success(response) {
							if (response && response.amenities) {
								$amenities.html(response.amenities);
							} else {
								console.warn('No amenities data found in response');
								$amenities.html('');
							}
						})
						.catch(function error(err) {
							console.error('Error loading specialty rate amenities:', err);
						});
				});

				// specialty rate policies
				$('.specialty-rate-policies').on('click', function _showSpecialtyRateDetails(e) {
					var rate_key = $(this).data('rate-key'),
						target_modal = $(this).data('target');

					e.preventDefault();

					if (!rate_key) {
						throw new Error('missing rate-key');
					}

					if (!target_modal) {
						throw new Error('missing data-target');
					}

					Adzuki.Ajax.get('/HotelSheets/getSpecialtyRateDetails/' + rate_key)
						.then(function success(response) {
							$(target_modal).find('.modal-body').html(response);
						})
						.catch(function error(err) {
							console.error('Error fetching specialty rate details:', err);
								Adzuki.StatusMessage('Error', 'Unable to load specialty rate details.');
						});
				});

				// change room rate type
				$('.rate-select').click(function _updateRoomPrices() {
					var $selected       = $(this),
					    $room_container = $selected.closest('.hs-sheet-room'),
					    $ratesRoot      = $selected.closest('.hs-room-rates'),
					    rate_string     = $selected.val(),
					    giata_id        = $ratesRoot.data('giata-id'),
					    criteria        = $ratesRoot.data('criteria-encoded') || '',
					    booking_uri     = '/HotelSearch/selectSheetRate/' + giata_id + '/' + rate_string + '/' + criteria,
					    $booking_link   = $room_container.find('.select-rate');

					// Update prices
					$room_container.find('.room-total').html($selected.data('total') + ' Total');
					$room_container.find('.room-avg-per-night').html($selected.data('average') + ' <small>avg per night</small>');

					// Update booking link
					$booking_link.attr('href', Adzuki.get_url(booking_uri));
					$booking_link.attr('data-uri', Adzuki.get_url(booking_uri));
				});
			})
			.catch(function error(err) {
				console.error('Error fetching hotel room rates:', err);
				Adzuki.StatusMessage('Error', 'Unable to load hotel room rates.');
			});
	}

	function fancyTimeFormat(duration)
	{
		const hrs = ~~(duration / 3600);
		const mins = ~~((duration % 3600) / 60);
		const secs = ~~duration % 60;

		let ret = "";

		if (hrs > 0) {
			ret += "" + hrs + ":" + (mins < 10 ? "0" : ""); // eslint-disable-line no-implicit-coercion
		}

		ret += "" + mins + ":" + (secs < 10 ? "0" : "");  // eslint-disable-line no-implicit-coercion
		ret += "" + secs; // eslint-disable-line no-implicit-coercion

		return ret;
	}
}(jQuery, window.Adzuki || {}));
